<template>
  <div>
    <skeleton-loader v-if="loading"
                     class="block mb-2 text-sm font-medium rounded-lg"
                     bg-class="bg-skeleton-label"
                     style="height: 20px; border-radius: 9999px"
                     :styles="getSkeletonWidth"/>
    <label v-if="label && !loading" id="label">{{ label }}</label>
  </div>
</template>

<script setup lang="ts">

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const getSkeletonWidth = computed(() => {
  return "width: " + getTextWidth(props.label) + 'px';
});

const getTextWidth = (text: string) => {
  if (typeof document === 'undefined')
    return 180;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const element = document.getElementById('label');
  if (element && context && canvas) {
    context.font = getCanvasFont(element);
    return context.measureText(text).width;
  }
  return 180
};

const getCanvasFont = (el: HTMLElement) => {
  if (typeof window === 'undefined') return 'normal normal 400 14px "Work Sans", sans-serif';
  const style = window.getComputedStyle(el);
  return [
    style['font-style'],
    style['font-variant'],
    style['font-weight'],
    style['font-size'],
    style['font-family'],
  ].join(' ');
};

</script>